module.exports = __webpack_public_path__ + "img/mortadela.9bc6bbb9.jpg";